export enum CommonText {
  less = "Less...",
  more = "More...",
  close = "Close",
  cancel = "Cancel",
  ok = "OK",
  commit = "Commit",
  login = "Login",
  logout = "Log Out",
  password = "Password",
  isLoggedIn = "is logged in",
  enterLoginName = "Enter user login name",
  select = "Select",
  next = "Next",
  prev = "Prev",
  last = "Last",
  lastNext = "Last/Next",
  goBack = " Go Back",
  prevDay = "Prev Day",
  prevHour = "Prev Hour",
  nextDay = "Next Day",
  nextHour = "Next Hour",
  clear = "Clear",
  skipped = "skipped",
  addNewDMPRecord = "Add New DMP Record",
  editDMPRecord = "Edit DMP Record",
  confirmDelete = "Confirm Delete",
  confirmDeleteBodyText = "Are you sure you want to delete this record?"
}

export enum FlightText {
  flight = "Flight",
  terminal = "Terminal",
  flightId = "Flight Id",
  id = "Id",
  slotId = "Slot Id",
  pprId = "PPR Id",
  departure = "Departure",
  arrival = "Arrival",
  turnaround = "Turnaround",
  outAndBack = "Out and Back",
  addPPR = "PPR",
  period = "Period",
  normalizePeriod = "Normalize Period",
  disableOvernightDeps = "Disable Overnight Departures",
  date = "Date",
  reqDate = "Req Date",
  routing = "Routing",
  airport = "Airport",
  airports = "Airports",
  seats = "Seats",
  reqTime = "Req Time",
  airportSeson = "Airport Season",
  aircraftType = "Aircraft type",
  operator = "Operator",
  operators = "Operators",
  constraint = "Constraint",
  excluded = "Excluded",
  serviceNo = "Serv No",
  depFlt = "DepFlt",
  st = "STC",
  servType = "Serv Type",
  f = "F",
  fm = "FM",
  fr = "FR",
  o = "O",
  ops = "Ops",
  mgt = "MGT",
  doop = "DOOP",
  woop = "WOOP",
  dest = "Dest",
  last = "Last",
  next = "Next",
  acReg = "A/C Reg",
  acType = "A/C Type",
  responseCode = "C",
  arrFlt = "ArrFlt",
  ad = "A/D",
  ap = "A/P",
  sts = "Sts",
  aft = "Aft",
  aRoute = "ARoute",
  dRoute = "DRoute",
  code = "Code",
  reason = "Reason",
  serviceType = "Service Type",
  clearTime = "Clear Time",
  clearCode = "Clear Code",
  time = "Time",
  clearTimeRange = "Cleared Time Range",
  timeRange = "Time Range",
  clearTimeTwo = "ClearTime",
  clearedTimeDep = "clearedTimeDep",
  requiredTimeRange = "Required Time Range",
  waitlistOnly = "Waitlist Only",
  excludeSlotsFlights = "Exclude ‘No Slot’ Flights",
  noSlotFlightIOnly = "‘No Slot’ Flights Only",
  origin = "Orig",
  origDest = "Orig/Dest",
  searchTimeRange = "Search Time Range",
  dateRange = "Date Range",
  range = "Range",
  fragmentOpt = "Fragment options",
  split = "Split",
  arrDep = "Arr/Dep",
  arr = "Arr",
  dep = "Dep",
  delink = "Delink",
  both = "Both",
  no = "No",
  byDoop = "By DOOP",
  byDays = "By Dates",
  utcText = "UTC",
  localText = "Local",
  times = "Times",
  minGroundTime = "Min Ground Time",
  lastUpdate = "Last Update",
  lastUpdateCanceled = "Cancelled Since Date",
  viewSubmitted = "View Submitted",
  requestCode = "Code",
  waitlist = "Waitlist only",
  noslotsOnly = "noslotsOnly",
  excludeNoslots = "excludeNoslots",
  schedule = "Schedule",
  value = "Value",
  adt = "A/D/T",
  servNo = "Service No",
  station = "Station",
  overnightIndicator = "Overnight Indicator",
  hour = "Hour",
  groupby = "Group by",
  sumBy = "Sum by",
  sumOf = "Sum of",
  handler = "Handler",
  handling = "Handling",
  other = "Other",
  vfrCaption = "Flight Rule",
  towbar = "Towbar",
  noise = "Noise",
  vfr = "VFR",
  ifr = "IFR",
  mtow = "MTOW",
  gl = "N/A",
  rf = "RF",
  opText = "Op Text",
  parkLoc = "ParkLoc",
  gabaLounge = "N/A",
  refuelling = "Refuel",
  operatorTextCaption = "Operator Name",
  ddSlotId = "DSlotId",
  aSlotId = "ASlotId",
  dPPRId = "DPPRId",
  aPPRId = "APPRId",
  availability = "availability",
  disableNew = "Disable New",
  disableTime = "Disable Time",
  disableAc = "Disable A/C",
  fromTime = "From Time",
  toTime = "To Time",
  fromDate = "From Date",
  toDate = "To Date"
}

export enum ResponsePaneText {
  waitResponse = "Waiting for Response",
  response = "Response",
  waitInitResponse = "Waiting for Initial Response",
  initResponse = "Initial Response",
  waitFinalResponse = " Waiting for Final Response",
  finalResponse = " Final Response"
}

export enum BtnText {
  flightNo = "Flight No",
  addArrival = "Add Arrival",
  addDeparture = "Add Departure",
  addTurnAround = "Add Turnaround",
  addOutAndBack = "Add Out and Back",
  addHandler = "Add PPR",
  add = "Add",
  edit = "Edit",
  search = "Search",
  clearReg = "Clear Req",
  merge = "Merge",
  delink = "Delink",
  link = "Link",
  claimHistorics = "Claim Historics",
  change = "Change",
  delete = "Delete",
  accept = "Accept",
  pend = "Pend",
  decline = "Decline",
  swap = "Swap"
}

export enum FormText {
  select = "Select",
  searchHistory = "Search History",
  refresh = "Refresh",
  addToSearch = "Add to Search",
  submit = "Submit",
  upDate = "Update",
  sendAsBlock = "Send as Block",
  sendAll = "Send All",
  deselectAll = "Deselect All"
}

export enum ReplyCodeText {
  A = "Accept",
  P = "Pend",
  C = "Cancel",
  S = "Ask us",
  O = "Override",
  R = "Refuse",
  L = "Live only"
}

export enum flightModeText {
  A = "Arrival",
  D = "Departure",
  T = "Turnaround"
}

export enum ActionTypeText {
  CHANGE = "Change",
  SHLCHANGENOOFFER = "No Offer",
  SHLCHANGECONTINUATION = "Continuation",
  DELETE = "Delete",
  SEARCH = "Search",
  CLEARREQ = "Clear Req",
  MERGE = "Merge",
  SWAP = "Swap",
  ARRDEPSWAP = "Swap A/D",
  SWAPARRTODEP = "Swap A->D",
  SWAPDEPTOARR = "Swap D->A",
  SWAPLINK = "Swap Link",
  SWAPAC = "Swap A/C",
  SWAPPERIOD = "Swap Period",
  LINK = "Link",
  DELINK = "Delink",
  SHLHISTORICS = "Historics",
  ACCEPT = "Accept",
  PEND = "Pend",
  DECLINE = "Decline"
}

export enum FieldName {
  airport = "airport",
  availability = "Availability",
  airports = "airports",
  season = "season",
  operatorArr = "operatorArr",
  operatorDep = "operatorDep",
  operators = "operators",
  reqDate = "reqDate",
  excludeOper = "excludeOper",
  useOwnOperators = "useOwnOperators",
  serviceNoArr = "serviceNoArr",
  serviceNoDep = "serviceNoDep",
  serviceNumber = "serviceNumber",
  serviceNumberTo = "serviceNumberTo",
  serviceTypeArr = "serviceTypeArr",
  serviceTypeDep = "serviceTypeDep",
  serviceTypes = "serviceTypes",
  startDate = "startDate",
  endDate = "endDate",
  normalizePeriod = "normalizePeriod",
  doop = "doop",
  woop = "woop",
  flightMode = "flightMode",
  delink = "delink",
  clearCode = "clearCode",
  clearedTimeArr = "clearedTimeArr",
  clearedTimeDep = "clearedTimeDep",
  clearedTimeFrom = "clearedTimeFrom",
  clearedTimeTo = "clearedTimeTo",
  requiredDateArr = "requiredDateArr",
  requiredDateDep = "requiredDateDep",
  requiredTimeArr = "requiredTimeArr",
  requiredTimeDep = "requiredTimeDep",
  requiredTimeFrom = "requiredTimeFrom",
  requiredTimeTo = "requiredTimeTo",
  waitlist = "waitlist",
  excludeNoslots = "excludeNoslots",
  noSlotFlightIOnly = "noSlotFlightIOnly",
  noslotsOnly = "noslotsOnly",
  reasonCodeArr = "reasonCodeArr",
  reasonCodeDep = "reasonCodeDep",
  turnaroundDays = "turnaroundDays",
  minGroundTime = "minGroundTime",
  aircraftType = "aircraftType",
  numSeats = "numSeats",
  aircraftRegistration = "aircraftRegistration",
  originStation = "originStation",
  destinationStation = "destinationStation",
  lastStation = "lastStation",
  nextStation = "nextStation",
  origDest = "origDest",
  lastNext = "lastNext",
  prevNext = "prevNext",
  offerTimeArr = "offerTimeArr",
  offerTimeDep = "offerTimeDep",
  offerTimeArrFrom = "offerTimeArrFrom",
  offerTimeArrTo = "offerTimeArrTo",
  offerTimeDepFrom = "offerTimeDepFrom",
  offerTimeDepTo = "offerTimeDepTo",
  terminalArr = "terminalArr",
  terminalDep = "terminalDep",
  terminal = "terminal",
  slotIdArr = "slotIdArr",
  slotIdDep = "slotIdDep",
  slotId = "slotId",
  requestCode = "requestCode",
  lastUpdate = "lastUpdate",
  viewSubmittedShl = "viewSubmittedShl",
  constraintType = "constraintType",
  schedule = "schedule",
  valueType = "valueType",
  adt = "adt",
  dayOfWeek = "dayOfWeek",
  hour = "hour",
  mergeTotals = "mergeTotals",
  overlayQuotaConstraints = "overlayQuotaConstraints",
  useHourlyConstraints = "useHourlyConstraints",
  date = "date",
  countries = "countries",
  siText = "siText",
  replyCode = "replyCode",
  viewRestricted = "viewRestricted",
  addToQuery = "addToQuery",
  useICAOCode = "useICAOCode",
  useLocalTime = "useLocalTime",
  reportFormat = "reportFormat",
  canxSinceDate = "canxSinceDate",
  responseCode = "responseCode",
  flightNoArr = "flightNoArr",
  flightNoDep = "flightNoDep",
  period = "period",
  periodTo = "periodTo",
  periodFrom = "periodFrom",
  periodToDate = "periodToDate",
  periodFromDate = "periodFromDate",
  periodToTime = "periodToTime",
  periodFromTime = "periodFromTime",
  clearedTimes = "clearedTimes",
  requiredTimes = "requiredTimes",
  reasonCodes = "reasonCodes",
  routeArr = "routeArr",
  routeDep = "routeDep",
  terminals = "terminals",
  noOfOperations = "noOfOperations",
  separateFiles = "separateFiles",
  separateDays = "separateDays",
  // ground handling
  handler = "handler",
  vfr = "vfr",
  flightRule = "flightRule",
  towbar = "towbar",
  mtow = "mtow",
  gabaLounge = "gabaLounge",
  refuelling = "refuelling",
  operatorText = "operatorText",
  // gtaa-ga
  parkingLocation = "parkingLocation",
  noiseCertificate = "noiseCertificate",
  departureDate = "departureDate",
  disableNew = "disableNew",
  disableTimeChange = "disableTimeChange",
  disableAcUpgrade = "disableAcUpgrade"
}

export enum userSettingsKey {
  showOptionalFields = "showOptionalFields",
  useSSIMView = "useSSIMView",
  pinSelectorPanel = "pinSelectorPanel"
}

export enum collapsedCardName {
  flightID = "flightID",
  period = "period",
  times = "times",
  other = "other",
  handling = "handling",
  checkboxes = "checkboxes"
}

export enum FragmentFieldName {
  separationOption = "separationOption",
  doop = "doop",
  splitOption = "splitOption",
  startDate = "startDate",
  endDate = "endDate"
}

export enum FilterKey {
  season = "season",
  time = "time",
  waitlist = "waitlist",
  excludeNoslots = "excludeNoslots",
  noslotsOnly = "noslotsOnly",
  airports = "airports",
  airport = "airport",
  operators = "operators",
  serviceTypes = "serviceTypes",
  flightMode = "flightMode",
  terminal = "terminal",
  startDate = "startDate",
  endDate = "endDate",
  dateRange = "dateRange",
  singleDate = "singleDate",
  doop = "doop",
  clearedTimeRange = "clearedTimeRange",
  requiredTimeRange = "requiredTimeRange",
  clearedTimeRangeFrom = "clearedTimeRangeFrom",
  requiredTimeRangeFrom = "requiredTimeRangeFrom",
  clearedTimeRangeTo = "clearedTimeRangeTo",
  requiredTimeRangeTo = "requiredTimeRangeTo",
  clearCode = "clearCode",
  aircraftType = "aircraftType",
  aircraftRegistration = "aircraftRegistration",
  origDest = "origDest",
  prevNext = "prevNext",
  serviceNumber = "serviceNumber",
  serviceNumberRange = "serviceNumberRange",
  lastUpdate = "lastUpdate",
  canxSinceDate = "canxSinceDate",
  slotId = "slotId",
  constraintType = "constraintType",
  valueType = "valueType",
  adt = "adt",
  date = "date",
  dayOfWeek = "dayOfWeek",
  hour = "hour",
  schedule = "schedule",
  noSlotFlightIOnly = "noSlotFlightIOnly",
  normalizePeriod = "normalizePeriod",
  delink = "delink"
}

export enum LoadingText {
  loadingAirportSeasons = "Loading Airport Seasons...",
  recievingRecords = "Recieving Records...",
  addingRecord = "Adding Record...",
  editingRecord = "Editing Record...",
  deletingRecord = "Deleting Record...",
  fetchingAvailability = "Fetching Availability...",
  mayTakeFewMin = "This may take a few minutes"
}
